interface NutriscoreBadgeProps {
  grade: string | null;
}

/**
 * Renders a color-coded Nutriscore letter badge (A–E).
 * A=#038141, B=#85BB2F, C=#FECB02, D=#EE8100, E=#E63E11
 */
export function NutriscoreBadge({ grade }: NutriscoreBadgeProps) {
  if (!grade) return <span style={{ color: 'var(--text-tertiary)' }}>{'\u2014'}</span>;

  const letter = grade.trim().toUpperCase();
  const validGrades = ['A', 'B', 'C', 'D', 'E'];

  if (!validGrades.includes(letter)) {
    return <span style={{ color: 'var(--text-tertiary)' }}>{grade}</span>;
  }

  return (
    <span class={`nutriscore-badge nutriscore-${letter.toLowerCase()}`}>
      {letter}
    </span>
  );
}
